module.exports = __webpack_public_path__ + "static/js/session.a150fe66.chunk.worker.js"